import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { PrivilegeBuilder } from '../../models/builders/privilege.builder';

@Injectable()
export class PrivilegeApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }privileges`;
  }

  getPrivileges() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(
        map(PrivilegeBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/privilege-api.service.ts